import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

const Services = () => {
    const navigate = useNavigate();

    // State for managing the number of visible items
    const [visibleItems, setVisibleItems] = useState(3);
    const [isExpanded, setIsExpanded] = useState(false);

    // Sample service data
    const services = [
        {
            title: "Distillation Column Internal",
            description:
                "Distillation Column Internal Revamp & Installation in Project & Shutdown Work. A distillation column internal revamp and installation project, often referred to as a revamp or revamp project, involves making significant changes to the internals of a distillation column to improve its performance, efficiency, or capacity. This type of project is typically carried out during a plant shutdown or turnaround.",
            link: "/Card01",
        },
        {
            title: "Distillation Column Maintenance",
            description:
                "Distillation Column Maintenance & Inspection Job. Maintenance and inspection of distillation columns are essential to ensure their safe and efficient operation in a chemical or petrochemical plant. Regular maintenance and inspections can help prevent issues, extend the lifespan of the equipment, and minimize unplanned shutdowns.",
            link: "/Card02",
        },
        {
            title: "Distillation Column Supervision",
            description:
                "Distillation Column Supervision & Inspection Job. Distillation column supervision and inspection jobs involve overseeing the operation of a distillation column, ensuring it performs efficiently, and conducting routine inspections to identify any issues that may require maintenance or repairs.",
            link: "/Card03",
        },
        {
            title: "Maintenance of Distillation Column",
            description:
                "All types of maintenance of distillation column expertise. Maintenance of distillation columns requires a range of expertise and skills to ensure the efficient and safe operation of these critical components in chemical and petrochemical processes.",
            link: "/Card04",
        },
        {
            title: "Maintenance & Inspection of Vessel",
            description:
                "Maintenance & Inspection of vessel, heat exchanger, piping, etc. Maintenance and inspection of vessels, heat exchangers, piping, and other process equipment are essential in industrial facilities to ensure safe and efficient operations.",
            link: "/Card05",
        },
        {
            title: "Project & Shutdown Job",
            description:
                "Project and shutdown job typically refers to a planned project that involves a temporary shutdown of a facility, unit, or specific equipment to perform maintenance, upgrades, modifications, or other significant work.",
            link: "/Card06",
        },
        {
            title: "Technical Advisor",
            description:
                "A technical advisor is an expert or consultant with specialized knowledge and experience in a particular technical field or industry. Their role is to provide guidance, advice, and support to individuals, organizations, or projects that require technical expertise.",
            link: "/Card07",
        },
        {
            title: "Green Field Project",
            description:
                "A greenfield project refers to a project that involves the construction, development, or establishment of a new facility, venture, or project from the ground up in an area or on a site that is entirely new, undeveloped, and free of any existing infrastructure or constraints.",
            link: "/Card08",
        },
    ];

    // Toggle visibility of more/less items
    const toggleLoadMore = () => {
        if (isExpanded) {
            setVisibleItems(3);
        } else {
            setVisibleItems(services.length);
        }
        setIsExpanded(!isExpanded);
    };

    return (
        <div>
            <div className='items-center text-center mt-20'>
                <h1 className="font-extrabold text-2xl md:text-3xl text-purple-800 mb-2">
                    Our Services
                </h1>
                <p className="font-bold text-lg md:text-xl text-blue-800 mb-4">
                    We provide high standard work for your Company solutions
                </p>
            </div>

            <div className='grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 2xl:px-20 m-10 mt-10'>
                {services.slice(0, visibleItems).map((service, index) => (
                    <div
                        key={index}
                        className='border p-6 shadow rounded-2xl hover:bg-purple-100 hover:scale-105 transition-all duration-300'
                    >
                        <div>
                            <h1 className='items-center text-center text-purple-800 text-xl font-bold my-5'>
                                {service.title}
                            </h1>
                            <p className='my-5'>
                                {service.description.slice(0, 149)}...
                            </p>

                            <div className="flex justify-center">
                                <button
                                    onClick={() => navigate(service.link)}
                                    className="bg-blue-600 text-white px-5 py-2 rounded-full hover:bg-blue-500 text-lg font-medium my-5"
                                >
                                    View More
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="flex justify-center">
                <button
                    onClick={toggleLoadMore}
                    className="bg-blue-600 text-white px-5 py-2 rounded-full hover:bg-blue-500 text-lg font-medium my-5"
                >
                    {isExpanded ? "Read Less" : "Read More"}
                </button>
            </div>
        </div>
    );
};

export default Services;
